// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"27ce1b6b","488":"1e71c2a1","796":"b274f720"}[chunkId] + ".chunk.js";
};